export default __webpack_public_path__ + "static/media/snapfooders_a.568e794d.svg";